import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { registerSW } from 'virtual:pwa-register';

import store from './state/store';
import './index.css'; // TODO: This needs types or sth
import App from './App';
import { asyncPersister } from './offline/persister';
import { queryClient } from './queryClient';

// Note: The below is for Tanstack Query Dev Tools to work and it doesn't emit any javascript, so it doesn't need any 'isDevelopment' guards:
declare global {
  interface Window {
    __TANSTACK_QUERY_CLIENT__:
    import('@tanstack/query-core')
    .QueryClient
  }
}

if (import.meta.env.DEV) {
  window.__TANSTACK_QUERY_CLIENT__ = queryClient
}

console.info(`Eclipse frontend build ${__BUILD_ID__}`);
(window as unknown as { __ECLIPSE_BUILD__: string }).__ECLIPSE_BUILD__ = __BUILD_ID__;

// Note: After a new release, and even though data is reloaded and cached when logging in, the old bundle was causing some lists to be empty,
// for example: the material drop-down in the loading page
registerSW({
  immediate: true,
  onRegisteredSW(_swUrl, registration) {
    if (!registration) return;
    setInterval(() => {
      if (navigator.onLine) registration.update().catch(() => undefined);
    }, 60 * 60 * 1000);
  },
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <StrictMode>
    <Provider store={store}>
      <PersistQueryClientProvider
        client={queryClient}
        persistOptions={{
          persister: asyncPersister,
          maxAge: 1000 * 60 * 60 * 24 * 7,
          // Note: A new build starts from an empty persisted cache, so data shaped by the previous release is
          // never restored into the new one.
          buster: __BUILD_ID__,
        }}
      >
        <App />
      </PersistQueryClientProvider>
    </Provider>
  </StrictMode>
);